import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputProps, TextField, TextFieldProps } from '@material-ui/core';
import FieldError from './FieldError';

const useStyles = makeStyles((theme: any) => ({
  root: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textField: {
    width: '100%',
    maxWidth: ({ maxWidth }: { maxWidth: number }) => maxWidth,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1.5),
      '&.Mui-focused': {
        '& fieldset': {
          borderColor: theme.palette.brand.oceanBlue,
        },
      },
    },
  },
  focusedLabel: {
    '&.MuiFormLabel-root.Mui-focused': {
      color: theme.palette.brand.oceanBlue,
    },
  },
  filledInputLabel: {
    '&.MuiFormLabel-root': {
      color: '#000',
    },
  },
}));

export interface InputTextFieldProps {
  errors?: Record<string, unknown>;
  type?: string;
  select?: boolean;
  label?: string;
  name?: string;
  defaultValue?: string;
  TextFieldProps?: Partial<TextFieldProps>;
  InputProps?: InputProps;
  maxWidth?: number;
  className?: string;
  autoFocus?: boolean;
  children?: React.ReactNode;
  [x: string]: any;
}

//TODO: need to add to storybook
export default function InputTextField({
  errors = {},
  type = 'input',
  select = false,
  label,
  name,
  defaultValue,
  TextFieldProps,
  InputProps = {},
  maxWidth = 300,
  className = null,
  autoFocus = false,
  children,
  ...restProps
}: InputTextFieldProps) {
  const classes = useStyles({ maxWidth });

  return (
    <div className={classes.root}>
      <TextField
        type={type}
        error={errors[name] ? true : false}
        className={classes.textField + ' ' + className}
        id={name}
        autoFocus={autoFocus}
        label={label}
        select={select}
        variant="outlined"
        defaultValue={defaultValue}
        {...TextFieldProps}
        InputProps={InputProps}
        InputLabelProps={{
          classes: {
            shrink: classes.filledInputLabel,
            focused: classes.focusedLabel,
          },
        }}
        {...restProps}
      >
        {children}
      </TextField>
      <FieldError {...{ errors, name }} />
    </div>
  );
}
